import { Dialog, Grid, IconButton } from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MyContext from "../../../contexts/MyContext";
import { AddReceipt } from "./AddReceipt";
import { TransportationType, ValidTextRegExp } from "../../../Constant";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import { MyNumberField } from "../../../components/my-number-field/MyNumberField";
import { MyButton } from "../../../components/my-button/MyButton";

export const AddTransportReceiptDialog = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [fromAddress, setFromAddress] = useState(myContext.fromAddress);
  const [toAddress, setToAddress] = useState(myContext.toAddress);
  const [kmDriven, setKmDriven] = useState(myContext.numberOfKmDriven);
  const handleSaveOthers = (receipt, totalCost) => {
    myContext.changeTransportReceipt(receipt);
    myContext.changeTransportTotalCost(totalCost);
    props.onClose();
  };

  const handleSaveOwnCar = () => {
    myContext.changeFromAddress(fromAddress);
    myContext.changeToAddress(toAddress);
    myContext.changeNumberOfKmDriven(kmDriven);
    props.onClose();
  };

  useEffect(() => {
    if (!props.open) {
      setFromAddress(myContext.fromAddress);
      setToAddress(myContext.toAddress);
      setKmDriven(myContext.numberOfKmDriven);
    }
  }, [props.open]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <Dialog fullScreen open={props.open} onClose={props.onClose}>
          <MuiDialogTitle component="span">
            <IconButton aria-label={t("close")} style={{ float: "right" }} onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </MuiDialogTitle>
          <Grid container justifyContent="center" className="container custom">
            <Grid item className="padding left-1 right-1">
              <p>
                <h2>{t("add_receipt_for_expenses")}</h2>
              </p>
              {context.transportationType === TransportationType.OTHERS && <p>{t("add_all_receipts_for_alternative_transport")}</p>}
              <FormControl component="fieldset">
                <RadioGroup value={context.transportationType} onChange={(e, value) => context.changeTransportationType(value)}>
                  <FormControlLabel value={TransportationType.USEOWNCAR} control={<Radio />} label={t("use_my_own_car")} />
                  <FormControlLabel value={TransportationType.OTHERS} control={<Radio />} label={t("other_transportation")} />
                </RadioGroup>
              </FormControl>
              <div style={{ display: context.transportationType === TransportationType.USEOWNCAR ? "initial" : "none" }}>
                <MyTextField maxLength={100} regExp={ValidTextRegExp} label={t("from_address")} value={fromAddress} onChange={setFromAddress} />
                <MyTextField maxLength={100} regExp={ValidTextRegExp} label={t("to_address")} value={toAddress} onChange={setToAddress} />
                <MyTextField regExp={"^[0-9]*$"} type="text" label={t("number_of_km_driven")} value={kmDriven} onChange={setKmDriven} />
                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                  <Grid item>
                    <MyButton className="button primary" onClick={props.onClose} color="default" text={t("back")} buttonVariant="outlined" />
                  </Grid>
                  <Grid item>
                    <MyButton className="button primary" text={t("save_and_close")} onClick={handleSaveOwnCar} />
                  </Grid>
                </Grid>
              </div>
              <div style={{ display: context.transportationType === TransportationType.OTHERS ? "initial" : "none" }}>
                <p>
                  <small>{t("max_25MB_per_file")}</small>
                </p>
                <AddReceipt totalCost={context.transportTotalCost} onSave={handleSaveOthers} receipt={context.transportReceipt} {...props} />
              </div>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </MyContext.Consumer>
  );
};
